<template>
  <div style="position: relative;">
    <el-form ref="requirementListFilter" :model="requirementList" :size="defaultFormItemSize"
      label-width="120px" label-position="right" @submit.native.prevent
    >
      <filter-box :item-width="400" style="justify-content: normal">

        <el-form-item label="需求主题" prop="formFilter.subjectName">
          <el-input class="filter-item" v-model="requirementList.formFilter.subjectName"
            :clearable="true" placeholder=""
          />
        </el-form-item>
        <el-form-item label="需求类型" prop="formFilter.subjectType">
          <el-select class="filter-item" v-model="requirementList.formFilter.subjectType" :clearable="true" filterable
            placeholder="" :loading="requirementList.subjectType.impl.loading"
            @visible-change="requirementList.subjectType.impl.onVisibleChange"
            @change="onSubjectTypeValueChange">
            <el-option v-for="item in requirementList.subjectType.impl.dropdownList" :key="item.id"
              :value="item.id" :label="item.name"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="审核状态" prop="formFilter.auditStatus">
          <el-select class="filter-item" v-model="requirementList.formFilter.auditStatus" :clearable="true" filterable
                     placeholder="" :loading="requirementList.auditStatus.impl.loading"
                     @visible-change="requirementList.auditStatus.impl.onVisibleChange"
                    >
            <el-option v-for="item in requirementList.auditStatus.impl.dropdownList" :key="item.id"
                       :value="item.id" :label="item.name"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="对接状态" prop="formFilter.isDocking">
          <el-select class="filter-item" v-model="requirementList.formFilter.isDocking" :clearable="true" filterable
                     placeholder="" :loading="requirementList.isDocking.impl.loading"
                     @visible-change="requirementList.isDocking.impl.onVisibleChange"
          >
            <el-option v-for="item in requirementList.isDocking.impl.dropdownList" :key="item.id"
                       :value="item.id" :label="item.name"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="是否帮助上传" prop="formFilter.isHelp">
          <el-select class="filter-item" v-model="requirementList.formFilter.isHelp" :clearable="true" filterable
                     placeholder="" :loading="requirementList.isHelp.impl.loading"
                     @visible-change="requirementList.isHelp.impl.onVisibleChange"
          >
            <el-option v-for="item in requirementList.isHelp.impl.dropdownList" :key="item.id"
                       :value="item.id" :label="item.name"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="地区" prop="formFilter.areaId">
          <el-cascader class="filter-item"  v-model="requirementList.areaId.value"
                       :options="requirementList.areaId.impl.dropdownList" filterable
                       :clearable="true" :show-all-levels="false" placeholder="地区"
                       :props="{value: 'id', label: 'name'}"
                       @visible-change="requirementList.areaId.impl.onVisibleChange"
                       @change="onAreaIdValueChange"
          />
        </el-form-item>
        <el-button slot="operator" type="default" :plain="true" :size="defaultFormItemSize" @click="onResetRequirementList">重置</el-button>
        <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize" @click="refreshRequirementList(true)">查询</el-button>
        <el-button slot="operator" type="primary" :size="defaultFormItemSize" :disabled="!checkPermCodeExist('requirementList:requirementList:requirementFormAdd')"
          @click="onRequirementFormAddClick()">
          新增需求
        </el-button>
<!--        <el-button slot="operator" type="primary" :size="defaultFormItemSize"-->
<!--                   @click="onStartTaskClick()">-->
<!--          新增需求-->
<!--        </el-button>-->
      </filter-box>
    </el-form>
    <el-row>
      <el-col :span="24">
        <el-table ref="requirement" :data="requirementList.Requirement.impl.dataList" :size="defaultFormItemSize" @sort-change="requirementList.Requirement.impl.onSortChange"
          header-cell-class-name="table-header-gray"
          highlight-current-row @current-change="requirementList.Requirement.impl.currentRowChange"
        >
          <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" :index="requirementList.Requirement.impl.getTableIndex" />
          <el-table-column label="创建人" prop="createUserIdDictMap.name">
          </el-table-column>
          <el-table-column label="需求主题" prop="subjectName">
          </el-table-column>
          <el-table-column label="关键词" prop="keyWord">
          </el-table-column>
          <el-table-column label="需求主体联系人" prop="mainContact">
          </el-table-column>
          <el-table-column label="需求主体手机" prop="mainPhone">
          </el-table-column>
          <el-table-column label="需求类型" prop="subjectTypeDictMap.name">
          </el-table-column>
<!--          <el-table-column label="需求专家" prop="specialistIdsDictMap.name">-->
<!--          </el-table-column>-->
          <el-table-column label="创建时间" prop="createTime">
            <template slot-scope="scope">
              <span>{{formatDateByStatsType(scope.row.createTime, 'day')}}</span>
            </template>
          </el-table-column>
          <el-table-column label="审核状态" prop="auditStatusDictMap.name">
          </el-table-column>
          <el-table-column label="对接状态" prop="isDockingDictMap.name">
          </el-table-column>
          <el-table-column label="操作" fixed="right">
            <template slot-scope="scope">

              <el-button v-if="scope.row.auditStatus !=='0' || scope.row.createUserId===userInfo.userId"
                         @click.stop="onRequirementFormClick(scope.row)"
                         type="text"
                         :size="defaultFormItemSize"
                :disabled="!checkPermCodeExist('requirementList:requirementList:requirementForm')">
                查看编辑
              </el-button>
              <el-button  v-if="scope.row.auditStatus ==='0' && userInfo.isSpecial!='1'"
                          @click.stop="onRequirementFormClick(scope.row)"
                          type="text" :size="defaultFormItemSize"
                         :disabled="!checkPermCodeExist('requirementList:requirementList:requirementForm')">
                查看审核
              </el-button>
<!--              <el-button @click.stop="applyDocking(scope.row)" v-if="scope.row.isDocking === 0" type="text"-->
<!--                         :size="defaultFormItemSize">-->
<!--                申请对接-->
<!--              </el-button>-->
              <el-button @click.stop="onDeleteClick(scope.row)"  v-if="userInfo.isSpecial!='1' " type="text" :size="defaultFormItemSize"
                         :disabled="!checkPermCodeExist('requirementList:requirementList:delete')">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-row type="flex" justify="end" style="margin-top: 10px;">
          <el-pagination
            :total="requirementList.Requirement.impl.totalCount"
            :current-page="requirementList.Requirement.impl.currentPage"
            :page-size="requirementList.Requirement.impl.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, prev, pager, next, sizes"
            @current-change="requirementList.Requirement.impl.onCurrentPageChange"
            @size-change="requirementList.Requirement.impl.onPageSizeChange">
          </el-pagination>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin, cachePageMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { RequirementController, DictionaryController ,RequirementRelateController} from '@/api';
// import { FlowOperationController } from '@/api/flowController.js'
//
import { FlowOperationController } from '@/api/flowController.js';

const processDefinitionKey = 'flowRequirementAudit';
const processDefinitionName = '需求审核流程';
export default {
  name: 'requirementList',
  props: {
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin],
  data () {
    return {
      requirementList: {
        formFilter: {
          subjectName: undefined,
          subjectType: undefined,
          auditStatus: undefined,
          isHelp: undefined,
          isDocking: undefined,
          areaId: undefined
        },
        formFilterCopy: {
          subjectName: undefined,
          subjectType: undefined,
          auditStatus: undefined,
          isHelp: undefined,
          areaId: undefined,
          isDocking: undefined

        },
        Requirement: {
          impl: new TableWidget(this.loadRequirementWidgetData, this.loadRequirementVerify, true, true, 'createTime', 1)
        },
        subjectType: {
          impl: new DropdownWidget(this.loadSubjectTypeDropdownList)
        },
        auditStatus: {
          impl: new DropdownWidget(this.loadAuditStatusDropdownList)
        },
        isDocking: {
          impl: new DropdownWidget(this.loadIsDockingDropdownList)
        },
        isHelp: {
          impl: new DropdownWidget(this.loadIsHelpDropdownList)
        },
        areaId: {
          impl: new DropdownWidget(this.loadAreaIdDropdownList, true, 'id', 'parentId'),
          value: []
        },
        isInit: false
      },
      userInfo: {}
    }
  },
  methods: {
    onResetRequirementList () {
      this.requirementList.areaId.value = []

      this.$refs.requirementListFilter.resetFields();
      this.refreshRequirementList(true);
    },
    /**
     * 需求对接表数据获取函数，返回Promise
     */
    loadRequirementWidgetData (params) {
      if (params == null) params = {};
      params = {
        ...params,
        requirementDtoFilter: {
          subjectName: this.requirementList.formFilterCopy.subjectName,
          subjectType: this.requirementList.formFilterCopy.subjectType,
          auditStatus: this.requirementList.formFilterCopy.auditStatus,
          isDocking: this.requirementList.formFilterCopy.isDocking,
          areaId: this.requirementList.formFilterCopy.areaId,
          isHelp: this.requirementList.formFilterCopy.isHelp
        },
        orderParam: [
          {
            fieldName: 'createTime',
            asc: false
          }
        ]
      }
      return new Promise((resolve, reject) => {
        RequirementController.list(this, params).then(res => {
          resolve({
            dataList: res.data.dataList,
            totalCount: res.data.totalCount
          });
          // 恢复当前选择行
          if (this.requirementList.Requirement.impl.currentRow !== null) {
            this.$nextTick(() => {
              let currentRow = findItemFromList(res.data.dataList, this.requirementList.Requirement.impl.currentRow.id, 'id');
              this.$refs.requirement.setCurrentRow(currentRow);
            });
          }
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 需求对接表数据获取检测函数，返回true正常获取数据，返回false停止获取数据
     */
    loadRequirementVerify () {
      this.requirementList.formFilterCopy.subjectName = this.requirementList.formFilter.subjectName;
      this.requirementList.formFilterCopy.subjectType = this.requirementList.formFilter.subjectType;
      this.requirementList.formFilterCopy.auditStatus = this.requirementList.formFilter.auditStatus;
      this.requirementList.formFilterCopy.isDocking = this.requirementList.formFilter.isDocking;
      this.requirementList.formFilterCopy.isHelp = this.requirementList.formFilter.isHelp;
      this.requirementList.formFilterCopy.areaId = this.requirementList.formFilter.areaId;
      return true;
    },
    loadAuditStatusDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictAuditStatusDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    loadIsDockingDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictIsDockingDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    loadIsHelpDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictYesOrNoDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    onAreaIdValueChange (value) {
      this.requirementList.formFilter.areaId = Array.isArray(value) ? value[value.length - 1] : undefined;
    },
    /**
     * 地区id下拉数据获取函数
     */
    loadAreaIdDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictAreaStreet(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 需求类型下拉数据获取函数
     */
    loadSubjectTypeDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictRSTypeDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 需求类型选中值改变
     */
    onSubjectTypeValueChange (value) {
    },
    /**
     * 更新需求管理列表
     */
    refreshRequirementList (reloadData = false) {
      if (reloadData) {
        this.requirementList.Requirement.impl.refreshTable(true, 1);
      } else {
        this.requirementList.Requirement.impl.refreshTable();
      }
      if (!this.requirementList.isInit) {
        // 初始化下拉数据
      }
      this.requirementList.isInit = true;
    },
    onStartTaskClick () {
      let params = {
        processDefinitionKey: processDefinitionKey
      }

      FlowOperationController.viewInitialTaskInfo(this, params).then(res => {
        if (res.data && res.data.taskType === this.SysFlowTaskType.USER_TASK && res.data.assignedMe) {
          this.$router.push({
            name: res.data.routerName || 'handlerFlowTask',
            query: {
              processDefinitionKey: processDefinitionKey,
              formId: res.data.formId,
              routerName: res.data.routerName,
              readOnly: res.data.readOnly,
              taskName: '启动流程',
              isDraft: true,
              flowEntryName: processDefinitionName,
              variableList: res.data.variableList,
              operationList: (res.data.operationList || []).filter(item => {
                return item.type !== this.SysFlowTaskOperationType.CO_SIGN && item.type !== this.SysFlowTaskOperationType.REVOKE;
              })
            }
          });
        } else {
          FlowOperationController.startOnly(this, {
            processDefinitionKey: processDefinitionKey
          }).then(res => {
            this.$message.success('启动成功！');
          }).catch(e => {});
        }
      }).catch(e => {});
    },
    /**
     * 删除
     */
    onDeleteClick (row) {
      let params = {
        id: row.id
      };

      this.$confirm('此操作将删除打卡记录需要重新打卡, 是否继续?', '提示', {
        type: 'warning'
      }).then(() => {
        RequirementController.delete(this, params).then(res => {
          this.$message.success('删除成功');
          this.requirementList.Requirement.impl.refreshTable(false, 1);
        }).catch(e => {});
      }).catch(() => {
      });
    },
    /**
     * 新增需求
     */
    onRequirementFormAddClick () {
      let params = {};

      params.closeVisible = 1;
      this.$router.push({name: 'requirementForm', query: params});
    },
    /**
     * 编辑查看
     */
    onRequirementFormClick (row) {
      let params = {
        id: row.id
      };

      params.closeVisible = 1;
      this.$router.push({name: 'requirementForm', query: params});
    },
    onResume () {
      this.refreshRequirementList();
    },
    initFormData () {
    },
    applyDocking (row) {
      // let params = {
      //   processDefinitionKey: processDefinitionKey
      // }
      // let that = this
      // FlowOperationController.viewInitialTaskInfo(this, params).then(res => {
      //   if (res.data && res.data.taskType === this.SysFlowTaskType.USER_TASK && res.data.assignedMe && 1 === 2) {
      //
      //   } else {
      //     FlowOperationController.startOnly(this, {
      //       processDefinitionKey: processDefinitionKey
      //     }).then(res => {
      //       this.$message.success('启动成功！');
      //     }).catch(e => {});
      //   }
      // }).catch(e => {});
      let startParams = {
        processDefinitionKey: 'flowRequirementRelateAudit',
        taskVariableData: {},
        flowTaskCommentDto: {
          'approvalType': 'save'
        },
        requirementRelateDto: {
          isDatasourceInit: false,
          requirementId: row.id,
          subjectName: row.subjectName
        },
        copyData: {}
      }
      RequirementRelateController.startAndTakeUserTaskFlowRequirementRelateAudit(this, startParams).then(res => {
        this.$message.success('申请成功！');
        this.refreshRequirementList(true)
      })
    },
    formInit () {
      this.refreshRequirementList();
    }
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
    this.userInfo = this.$store.state.userInfo
    console.log(this.userInfo)
  },
  watch: {
  }
}
</script>
